import { PartnerConfirmLinkDeleteModalComponent } from '@modules/partner-portal/components/modals/partner-confirm-link-delete-modal/partner-confirm-link-delete-modal.component';
import { PartnerFinishOnboardingModalComponent } from '@modules/partner-portal/components/modals/partner-finish-onboarding-modal/partner-finish-onboarding-modal.component';
import { PartnerOnboardAccountsModalComponent } from '@modules/partner-portal/components/modals/partner-onboard-accounts-modal/partner-onboard-accounts-modal.component';
import { PartnerAddOrganizationModalComponent } from '@modules/partner-portal/components/modals/partner-add-organization-modal/partner-add-organization-modal.component';
import { PartnerReonboardAccoutModalComponent } from '@modules/partner-portal/components/modals/partner-reonboard-accout-modal/partner-reonboard-accout-modal.component';
import { PartnerSelectOrgUnitModalComponent } from '@modules/partner-portal/components/modals/partner-select-org-unit-modal/partner-select-org-unit-modal.component';
import { PartnerGenerateLinksModalComponent } from '@modules/partner-portal/components/modals/partner-generate-links-modal/partner-generate-links-modal.component';
import { IPartnerModalTypes } from '@modules/partner-portal/interfaces/partner-modals.interface';
import { ModalItem } from '@app/components/modals/modal-item';
import { ModalService } from '@app/services/modal.service';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-shell-partners',
	templateUrl: './shell-partners.component.html',
	styleUrls: ['./shell-partners.component.scss'],
})
export class ShellPartnersComponent implements OnInit {
	constructor(private modalService: ModalService) {}

	public ngOnInit() {
		this.modalService.modals = this.getModals();
	}

	private getModals(): Array<ModalItem<any>> {
		return [
			new ModalItem(PartnerGenerateLinksModalComponent, {
				title: 'Generate CloudFormation links',
				type: IPartnerModalTypes.generateLinks,
			}),
			new ModalItem(PartnerConfirmLinkDeleteModalComponent, {
				title: 'Confirm link delete',
				type: IPartnerModalTypes.confirmLinkDelete,
			}),
			new ModalItem(PartnerOnboardAccountsModalComponent, {
				title: 'Onboard accounts',
				type: IPartnerModalTypes.onboardAccounts,
			}),
			new ModalItem(PartnerFinishOnboardingModalComponent, {
				title: 'Finish onboarding',
				type: IPartnerModalTypes.finishOnboarding,
			}),
			new ModalItem(PartnerAddOrganizationModalComponent, {
				title: 'Create new organization',
				type: IPartnerModalTypes.addOrganization,
			}),
			new ModalItem(PartnerSelectOrgUnitModalComponent, {
				title: 'Select organization unit',
				type: IPartnerModalTypes.selectOU,
			}),
			new ModalItem(PartnerReonboardAccoutModalComponent, {
				title: 'Generate CloudFormation links',
				type: IPartnerModalTypes.reonoboardAccounts,
			}),
		];
	}
}
